import { createSlice } from '@reduxjs/toolkit';
import { resetErrorSlice, resetStore } from '../../Actions';
// import { resetErrorSlice, resetStore } from '../../Actions';

const initialState = {
  errorData: {
    open: false,
    message: null
  },
  successData: {
    open: false,
    message: null,
    title: null,
    buttonLabel: null
  }
};

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    setApiError(state, action) {
      if (
        action.payload &&
        typeof action.payload === 'string' &&
        action.payload.includes('No payable records found for the given criteria')
      ) {
        return;
      }
      state.errorData.open = true;
      state.errorData.message = action.payload;
      state.successData = { ...initialState.successData, ...state.successData, open: false };
    },
    setApiSuccess(state, action) {
      const payload =
        typeof action.payload === 'string' ? { message: action.payload } : action.payload || {};
      state.successData = {
        open: true,
        message: payload.message ?? null,
        title: payload.title || null,
        buttonLabel: payload.buttonLabel || null
      };
      state.errorData = { ...initialState.errorData, ...state.errorData, open: false };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState); // clear store
    builder.addCase(resetErrorSlice, () => initialState); // clear error slice
  }
});

export const { setApiError, setApiSuccess } = errorSlice.actions;
export default errorSlice.reducer;
